export const COMPANY = {
  name: "OWRS Automotive Ltd",
  shortName: "OWRS",
  phone: "0116 456 1046",
  phoneTel: "01164561046",
  email: "info@owrs.co.uk",
  addressLines: [
    "Unit E Magna Road",
    "South Wigston",
    "Leicester",
    "LE18 4ZH",
  ],
  hours: "Mon – Fri  ·  08:00 – 17:00",
  logo: "/assets/owrs-logo.png",
};

export const EV_SERVICES = [
  {
    slug: "tesla-diagnostics",
    title: "Tesla Diagnostics & Servicing",
    body:
      "Manufacturer-grade diagnostics and scheduled servicing for the full Tesla range — Model 3, Model Y, Model S and Model X — by HV-trained technicians.",
  },
  {
    slug: "hv-battery",
    title: "HV Battery Repair & Replacement",
    body:
      "Module-level diagnosis, cell balancing, and full high-voltage battery pack replacement carried out safely under controlled HV procedures.",
  },
  {
    slug: "charge-port",
    title: "Charging Port Repairs",
    body:
      "Failed CCS, Type 2 and Tesla charging port inspection, repair and replacement — restoring rapid charging without dealer prices.",
  },
  {
    slug: "ptc-heater",
    title: "PTC Heater Replacement",
    body:
      "Common cabin heater failures on EVs and hybrids fully diagnosed and replaced with OE-quality parts.",
  },
  {
    slug: "hv-ac",
    title: "HV AC Repairs & Servicing",
    body:
      "Air-conditioning servicing is critical on EVs and hybrids — the same refrigerant loop feeds the cabin AND manages high-voltage battery thermal regulation. Neglected, it can directly impact battery life and range. We carry out specialist HV AC servicing, R1234yf refrigerant work and compressor diagnostics.",
  },
  {
    slug: "12v-battery",
    title: "12V Battery Failures",
    body:
      "The number one EV breakdown cause. Rapid diagnosis and replacement, plus parasitic-draw investigations.",
  },
  {
    slug: "brakes-suspension",
    title: "Brakes & Suspension",
    body:
      "EV-specific friction packages, regen-aware brake servicing, and suspension repairs for the additional weight of electric platforms.",
  },
  {
    slug: "alignment",
    title: "4-Wheel Alignment",
    body:
      "Hunter-grade geometry to protect tyre life on heavier EV platforms and restore precise steering feel.",
  },
  {
    slug: "remapping",
    title: "EV Remapping",
    body:
      "Performance and efficiency remapping available on selected EV makes and models — please get in touch to confirm your vehicle.",
  },
  {
    slug: "recovery",
    title: "EV Recovery (Trusted Partners)",
    body:
      "Specialist EV recovery arranged via our trusted partners — safe transport for high-voltage vehicles when you need it most.",
  },
];

export const PERFORMANCE_SERVICES = [
  {
    slug: "inspections",
    title: "Inspections & Diagnosis",
    body:
      "Comprehensive inspections using state-of-the-art equipment. We leave no stone unturned and give you a clear picture of your vehicle's health.",
  },
  {
    slug: "service-maintenance",
    title: "Service & Maintenance",
    body:
      "From oil changes and brake servicing to fluid flushes, all carried out to manufacturer schedules using high-quality parts.",
  },
  {
    slug: "running-issues",
    title: "Running Issues",
    body:
      "Mysterious noises, vibrations or performance hiccups — our technicians pinpoint the root cause and put it right.",
  },
  {
    slug: "electrics",
    title: "Electrics",
    body:
      "From malfunctioning sensors to complex wiring on modern Porsche and Land Rover platforms — diagnosed efficiently and repaired properly.",
  },
  {
    slug: "raceprep",
    title: "Race Prep & Geometry",
    body:
      "Suspension geometry, corner weights, and full race preparation for track-day enthusiasts and championship competitors.",
  },
  {
    slug: "mot",
    title: "MOT Testing (Via Trusted Partners)",
    body:
      "We organise MOT testing through our trusted partners on your behalf. Any remedial work is handled by us to our usual exacting standards. Drop the car with us and we take care of the rest, with no extra effort required from you.",
  },
];

export const WHY_US = [
  {
    slug: "hv-trained",
    title: "IMI-Trained Workforce",
    body:
      "Every member of our team is IMI-certified in high-voltage safety and EV repair procedures — a serious investment in the future of motoring.",
  },
  {
    slug: "experienced",
    title: "Foundations In Motorsport",
    body:
      "Our roots are in racing — and the attention to detail and precision that demands sits at the core of everything we do today. Porsche, Land Rover, Tesla — your vehicle is in safe hands.",
  },
  {
    slug: "professional",
    title: "Professional & Transparent",
    body:
      "Attention to detail, transparent pricing, and clear communication from the moment you walk through our doors.",
  },
  {
    slug: "location",
    title: "Easily Reached",
    body:
      "Based in South Wigston, Leicester — within easy reach of the M1, M69 and A5, with the M40, M42 and M6 all comfortably within a 45-minute drive.",
  },
  {
    slug: "remote",
    title: "Remote Assistance",
    body:
      "Our experienced technicians are a phone call away for breakdown advice, fault triage or guidance — wherever you are.",
  },
  {
    slug: "guarantee",
    title: "100% Satisfaction",
    body:
      "We stand behind every job we do. If you're not happy, neither are we — and we'll do what's needed to make it right.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Mr Shing",
    location: "Market Harborough",
    quote:
      "After being let down by usual local garages, Ollie was recommended to me by a friend. He did not disappoint. Meticulous, with attention to detail that's without doubt. So far he's fitted cambelts, alternator, springs, shocks, brakes and serviced cars for all of our family's cars.",
  },
  {
    name: "Mr Foster",
    location: "Foz Motorsport",
    quote:
      "Oliver is a friendly face who will not finish a job until it is done to a degree satisfactory to both himself and the customer. His experience, expertise and advice are second to none.",
  },
  {
    name: "Mr Fox",
    location: "Lutterworth",
    quote:
      "Professional yet amicable — a huge asset. I would not go anywhere else for work on my cars.",
  },
];

export const PRICING = [
  { item: "Diagnostic plug-in", price: "from £20" },
  { item: "Servicing (plus parts)", price: "from £20" },
  { item: "Brake pads replaced (plus parts)", price: "from £40" },
  { item: "Clutch replacements (plus parts)", price: "from £200" },
  { item: "EV HV battery diagnostic", price: "POA" },
];

export const GALLERY_PLACEHOLDERS = [
  { label: "Tesla Model 3 Service Bay", aspect: "tall" },
  { label: "HV Battery Inspection", aspect: "wide" },
  { label: "Porsche 911 Track Prep", aspect: "wide" },
  { label: "Land Rover Workshop", aspect: "tall" },
  { label: "EV Charge Port Repair", aspect: "wide" },
  { label: "Geometry Bay", aspect: "tall" },
];
